export enum RatingFilter {
  Rated = "any",
  NotRated = "none",
  RatedBad = "bad",
  RatedNeutral = "neutral",
  RatedGood = "good",
}

export const RatingFilterFormattedValues = {
  [RatingFilter.Rated]: "Rated",
  [RatingFilter.NotRated]: "Not rated",
  [RatingFilter.RatedGood]: "Rated: Great",
  [RatingFilter.RatedNeutral]: "Rated: Okay",
  [RatingFilter.RatedBad]: "Rated: Not good",
};
